import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { TenantLanguage } from '@askporter/client-grieg-lyric';
import { getCountryCodeFromLanguageCode } from '@askporter/utils';
import { TextField } from '../TextField';
import { Typography } from '../Typography';

interface Props {
  id: string;
  title: string | React.ReactNode;
  t: (key: string) => string;
  values: Record<string, string>;
  tenantLanguages: TenantLanguage[];
  minRows?: number;
  disabled?: boolean;
  readonly?: boolean;
  onChange?: (languageCode: string, value: string) => void;
  onBlur?: (languageCode: string, value: string) => void;
}

export const MultiLangTextField: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  title,
  values,
  tenantLanguages,
  minRows = 3,
  disabled,
  readonly,
  onChange,
  onBlur,
}: Props) => {
  return (
    <Box>
      <Box>{typeof title === 'string' ? <Typography variant="h3">{title}</Typography> : title}</Box>
      {(tenantLanguages || []).map(({ languageCode, languageName }) => (
        <Box key={languageCode} sx={{ mt: '20px' }}>
          <TextField
            fullWidth
            label={languageName}
            id={`${id}-${languageCode}`}
            disabled={disabled}
            value={values?.[languageCode]}
            multiline={true}
            minRows={minRows}
            onChange={(e) => onChange?.(languageCode, e?.target?.value)}
            onBlur={(e) => onBlur?.(languageCode, e?.target?.value)}
            slotProps={{
              htmlInput: {
                readOnly: readonly,
              },
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      width={32}
                      alt={`flag-${languageCode}`}
                      src={`/media/images/shared/flags/${getCountryCodeFromLanguageCode(languageCode)}.png`}
                    />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );
};
